import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import { Intervention } from 'src/app/models/intervention';
import { InterventionContentItem } from '../../../models/intervention-content-item';

export const getInterventionsSuccess = createAction(
  '[Intervention] Get Interventions Success',
  props<{ interventions: Intervention[] }>()
);

export const getInterventionsError = createAction(
  '[Intervention] Get Interventions Error',
  props<{ err: HttpErrorResponse }>()
);

export const selectIntervention = createAction(
  '[Intervention] Select Intervention',
  props<{ interventionId: number }>()
);

export const selectInterventionSuccess = createAction(
  '[Intervention] Select Intervention Success',
  props<{ selectedIntervention: Intervention }>()
);

export const setSelectedIntervention = createAction(
  '[Intervention] Set Selected Intervention',
  props<{ selectedIntervention: Intervention }>()
);

export const saveIntervention = createAction(
  '[Intervention] Save Intervention',
  props<{ intervention: Intervention }>()
);

export const saveInterventionSuccess = createAction(
  '[Intervention] Save Intervention Success',
  props<{ newIntervention: Intervention }>()
);

export const saveInterventionError = createAction(
  '[Intervention] Save Intervention Error',
  props<{ err: HttpErrorResponse }>()
);

export const updateIntervention = createAction(
  '[Intervention] Update Intervention',
  props<{ intervention: Intervention }>()
);

export const updateInterventionSuccess = createAction(
  '[Intervention] Update Intervention Success',
  props<{ updatedIntervention: Intervention }>()
);

export const updateInterventionError = createAction(
  '[Intervention] Update Intervention Error',
  props<{ err: HttpErrorResponse }>()
);

export const deleteIntervention = createAction(
  '[Intervention] Delete Intervention',
  props<{ intervention: Intervention }>()
);

export const deleteInterventionSuccess = createAction(
  '[Intervention] Delete Intervention Success',
  props<{ deletedIntervention: Intervention }>()
);

export const deleteInterventionError = createAction(
  '[Intervention] Delete Intervention Error',
  props<{ err: HttpErrorResponse }>()
);

export const duplicateIntervention = createAction(
  '[Intervention] Duplicate Intervention',
  props<{ intervention: Intervention }>()
);

export const duplicateInterventionSuccess = createAction(
  '[Intervention] Duplicate Intervention Success',
  props<{ duplicatedIntervention: Intervention }>()
);

export const duplicateInterventionError = createAction(
  '[Intervention] Duplicate Intervention Error',
  props<{ err: HttpErrorResponse }>()
);

export const finishSession = createAction('[Intervention] Finish Session', props<{ intervention: Intervention }>());

export const finishSessionSuccess = createAction(
  '[Intervention] Finish Session Success',
  props<{ intervention: Intervention }>()
);

export const finishSessionError = createAction(
  '[Intervention] Finish Session Error',
  props<{ err: HttpErrorResponse }>()
);

export const getIntervention = createAction(
  '[Intervention] Get Intervention',
  props<{ studyId: number; interventionId: number }>()
);

export const getInterventionSuccess = createAction(
  '[Intervention] Get Intervention Success',
  props<{ intervention: Intervention }>()
);

export const getInterventionError = createAction(
  '[Intervention] Get Intervention Error',
  props<{ err: HttpErrorResponse }>()
);

export const setStartModule = createAction(
  '[Intervention] Set Start Module ',
  props<{ studyId: number; interventionId: number; moduleId: number }>()
);

export const setStartModuleSuccess = createAction(
  '[Intervention] Set Start Module Success',
  props<{ interventionContentItem: InterventionContentItem }>()
);

export const setStartModuleError = createAction(
  '[Intervention] Set Start Module Error',
  props<{ err: HttpErrorResponse }>()
);

export const resetStartModuleSetFlag = createAction('[Intervention] Reset Start Module Set Flag');

export const updateNonDefaultInterventions = createAction(
  '[Intervention] Update Non Default Interventions',
  props<{ nonDefaultInterventions: Intervention[] }>()
);
